/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Typography,
  notification,
  DatePicker,
  Button,
  Select,
  Radio,
  Divider,
  Space,
  Checkbox,
} from 'antd';
import { FilterFilled, SettingOutlined } from '@ant-design/icons';
import moment from 'moment';
import { any } from 'prop-types';
import { OnFetchWeldTestDetails, OnGeneratePQtReports } from '../../redux/PQTlogDetails/saga';
import ProjectHeatProfileList from './ProjectHeatProfileList_styled';
import ProjectHeatProfile from './ProjectHeatProfile';
import MaterialsWeatherInspectionModal from './MaterialsWeatherInspectionModal';
import axiosConfig from '../../redux/PQTlogDetails/axiosConfig1';
// import { delay } from 'lodash';

const { Title, Text } = Typography;
const { Option } = Select;
var obj = {
  fromDate: '22-03-2022',
  toDate: '22-03-2023',
  sowId: 1,
  format: 'CSV',
  email: '',
  generatedBy: '',
  projectId: 1,
  generateReport: false,
};
const GenerateReport = (props) => {
  const {
    isReportModalVisible,
    setIsReportModalVisible,
    setLocationData,
    locationData,
    projectIdValue,
    onGenerateReport,
    isLogReportsLoading,
    isWriteAccess,
    selectedSOW,
    selectedProject,
    pipelineList,
    setFileURL,
    onViewDetails,
    /** `{ fromDate, toDate }` from PQT `LogCalender` — materials / weather / inspection API */
    logDateRange,
    /** After successful PQT weld recalculate, bump key so `LogCalender` refetches inspection report rows */
    onAfterRecalculateSuccess,
  } = props;

  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const [pipeline, setPipeline] = useState([]);
  const [format, setFormat] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loadingReport, setLoadingReport] = useState(false);
  const [loadingWeldIds, setLoadingWeldIds] = useState(false);
  const [weldTestList, setWeldTestList] = useState([]);

  // Heat Profile state variables
  const [isHeatProfileModalVisible, setIsHeatProfileModalVisible] = useState(false);
  const [showHeatProfileForm, setShowHeatProfileForm] = useState(false);
  const [editingHeatProfile, setEditingHeatProfile] = useState(null);

  // New state variables for Project-Based Heat Profile
  const [includeHeatProfile, setIncludeHeatProfile] = useState(false);
  const [selectedHeatProfileIds, setSelectedHeatProfileIds] = useState([]);
  const [heatProfileList, setHeatProfileList] = useState([]);
  const [loadingHeatProfiles, setLoadingHeatProfiles] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [generatedReportUrl, setGeneratedReportUrl] = useState(null);
  const [pqtWeldRecalculateLoading, setPqtWeldRecalculateLoading] = useState(false);
  const [isRecalculateModalVisible, setIsRecalculateModalVisible] = useState(false);
  const [recalculateModalPayload, setRecalculateModalPayload] = useState(null);

  const [reportForm] = Form.useForm();

  // Function to fetch data based on date range
  const fetchWeldTestDetails = async (start, end) => {
    if (!selectedSOW) return;
    if (start && end) {
      var fromDate = moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      var toDate = moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      const obj = {
        startDate: fromDate,
        endDate: toDate,
        sowId: selectedSOW.id,
      };

      const list = await OnFetchWeldTestDetails(obj);
      console.log('Fetched Weld Test Data:', list);

      if (list && list.length > 0) {
        setWeldTestList(list);
      } else {
        setWeldTestList([]);
      }
    }
  };

  // Function to fetch heat profile report numbers
  const fetchHeatProfileList = async () => {
    if (!selectedProject?.id) return;

    setLoadingHeatProfiles(true);
    try {
      // Make actual API call to fetch heat profile list
      const response = await axiosConfig.get('/project-heat-profile/list-for-report', {
        params: { id: selectedProject.id },
      });

      // Extract data from response - API returns {message: "success", data: [...]}
      const heatProfileData = response.data?.data || [];

      setHeatProfileList(heatProfileData);
    } catch (error) {
      console.error('Error fetching heat profile list:', error);
      notification.error({
        message: 'Failed to fetch heat profile list',
        description: error?.response?.data?.message || 'Please try again later',
      });
      setHeatProfileList([]);
    } finally {
      setLoadingHeatProfiles(false);
    }
  };

  // Heat Profile handlers
  const showHeatProfileModal = () => {
    setIsHeatProfileModalVisible(true);
    setShowHeatProfileForm(false);
    setEditingHeatProfile(null);
  };

  const handleHeatProfileCancel = () => {
    setIsHeatProfileModalVisible(false);
    setShowHeatProfileForm(false);
    setEditingHeatProfile(null);
  };

  const handleCreateHeatProfile = () => {
    setShowHeatProfileForm(true);
    setEditingHeatProfile(null);
  };

  const handleEditHeatProfile = (record) => {
    setEditingHeatProfile(record);
    setShowHeatProfileForm(true);
  };

  const handleHeatProfileFormClose = () => {
    setShowHeatProfileForm(false);
    setEditingHeatProfile(null);
  };

  /** POST /pqt-weld/recalculate-overall-status — body `{ sowId, date }` (`axiosConfig1`). Returns whether the request succeeded. */
  const executeRecalculatePqtWeld = async (sowId, datePayload) => {
    setPqtWeldRecalculateLoading(true);
    try {
      await axiosConfig.post('/pqt-weld/recalculate-overall-status', {
        sowId,
        date: datePayload,
      });
      if (logDateRange?.fromDate && logDateRange?.toDate) {
        onAfterRecalculateSuccess?.();
      }
      notification.success({
        message: 'Recalculate requested',
        description:
          logDateRange?.fromDate && logDateRange?.toDate
            ? 'Overall status was recalculated; the inspection log table was refreshed for the current date range.'
            : 'Overall status is being recalculated for this SOW. Open a calendar range to refresh the log table.',
      });
      return true;
    } catch (error) {
      const desc =
        error?.message ||
        error?.response?.data?.message ||
        error?.error ||
        'Failed to recalculate. Please try again.';
      notification.error({
        message: 'Recalculate failed',
        description: typeof desc === 'string' ? desc : JSON.stringify(desc),
      });
      return false;
    } finally {
      setPqtWeldRecalculateLoading(false);
    }
  };

  const handleRecalculateModalCancel = () => {
    setIsRecalculateModalVisible(false);
    setRecalculateModalPayload(null);
  };

  const handleRecalculateModalProceed = async () => {
    if (!recalculateModalPayload) return;
    const { sowId, datePayload } = recalculateModalPayload;
    const ok = await executeRecalculatePqtWeld(sowId, datePayload);
    if (ok) {
      setIsRecalculateModalVisible(false);
      setRecalculateModalPayload(null);
    }
  };

  const handleRecalculatePqtWeld = () => {
    const sowId = selectedSOW?.id;
    if (sowId == null || sowId === '') {
      notification.warning({
        message: 'Select a pipeline',
        description: 'Choose a SOW (pipeline) before recalculating.',
      });
      return;
    }
    const dateRaw = logDateRange?.fromDate ?? startDate;
    if (!dateRaw) {
      notification.warning({
        message: 'Date required',
        description: 'Pick a calendar range or report date before recalculating.',
      });
      return;
    }
    const dateM = moment.utc(dateRaw, ['YYYY-MM-DD', moment.ISO_8601], true);
    if (!dateM.isValid()) {
      notification.warning({
        message: 'Invalid date',
        description: 'Use a valid date (YYYY-MM-DD).',
      });
      return;
    }
    const datePayload = dateM.format('YYYY-MM-DD');
    setRecalculateModalPayload({ sowId, datePayload });
    setIsRecalculateModalVisible(true);
  };

  const showModal = async () => {
    setIsReportModalVisible(true);
    // if (selectedSOW)
    //     setPipeline(selectedSOW.pipelineSection)

    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      var userName = user?.name || '';
      setName(userName);

      reportForm.setFieldsValue({ name: userName });
    }

    const start = moment().startOf('month').format('YYYY-MM-DD');
    const end = moment().endOf('month').format('YYYY-MM-DD');
    setStartDate(start);
    setEndDate(end);

    // Reset form state
    setReportGenerated(false);
    setGeneratedReportUrl(null);
    setIncludeHeatProfile(false);
    setSelectedHeatProfileIds([]);

    // Set default current month dates & fetch data
    fetchWeldTestDetails(start, end);

    // Fetch heat profile list
    await fetchHeatProfileList();
  };

  const handleOk = () => {
    // // if (reportGenerated && generatedReportUrl) {
    //     // Handle sharing the report
    //     handleShareReport();
    // // } else {
    // Handle generating the report
    handleGenerateReport();
    // }
  };

  const handleGenerateReport = () => {
    console.log('Starting report generation...'); // Debug log
    console.log('Current form state:', {
      startDate,
      endDate,
      name,
      pipeline,
      includeHeatProfile,
      selectedHeatProfileIds,
    }); // Debug log

    reportForm
      .validateFields()
      .then(async (data) => {
        console.log('Form validation data:', data); // Debug log

        // Get current form values
        const currentName = data.name || name;
        if (!data.email) {
          notification.warning({
            message: 'Provide Email to proceed!',
          });
          return;
        }
        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emails = data.email.split(',').map((email) => email.trim());
        const invalidEmails = emails.filter((email) => !emailRegex.test(email));

        if (invalidEmails.length > 0) {
          notification.error({
            message: 'Invalid email format',
            description: `Please check: ${invalidEmails.join(', ')}`,
          });
          return;
        }

        if (!startDate) {
          notification.warning({
            message: 'Select From Date to proceed!',
          });
          return;
        }
        if (!endDate) {
          notification.warning({
            message: 'Select To Date to proceed!',
          });
          return;
        }
        if (!currentName) {
          notification.warning({
            message: 'Provide Name to proceed!',
          });
          return;
        }
        if (pipeline.length == 0) {
          notification.warning({
            message: 'Select Welds to proceed!',
          });
          return;
        }
        if (includeHeatProfile && selectedHeatProfileIds.length == 0) {
          notification.warning({
            message: 'Select Heat Profile Report Numbers to proceed!',
          });
          return;
        }

        console.log('All validations passed, proceeding with report generation...'); // Debug log

        // Proceed with report generation
        var sowId = selectedSOW.id;

        let allWelds = pipeline.includes('All')
          ? weldTestList.map((item) => String(item.weldId)) // Ensure IDs are strings
          : pipeline.filter((value) => value !== 'All').map(String); // Convert to string
        var fromDate = moment(startDate).startOf('day').toISOString(); // 00:00:00.000Z
        var toDate = moment(endDate).endOf('day').toISOString(); // 23:59:59.999Z
        console.log('selected weld IDs', allWelds);

        var obj = {
          fromDate: fromDate,
          toDate: toDate,
          sowId: sowId,
          format: 'PDF',
          weldIds: allWelds,
          generatedBy: currentName,
          projectId: selectedProject.id,
          generateReport: true,
          heatProfiles: includeHeatProfile ? selectedHeatProfileIds : [],
          emailToDestinations: data.email,
        };

        console.log('Report request object:', obj); // Debug log

        if (fromDate > toDate) {
          notification.warn({
            message: 'From date should be previous than To date',
          });
        } else {
          setLoadingReport(true);
          console.log('Calling OnGeneratePQtReports...'); // Debug log
          const reportUrl = await OnGeneratePQtReports(obj);
          console.log('Report URL received:', reportUrl); // Debug log

          if (reportUrl) {
            setGeneratedReportUrl(reportUrl);
            setReportGenerated(true);

            let fileName = reportUrl.split('/').pop(); // Gets the last part of the URL
            fileName = decodeURIComponent(fileName); // Decodes any encoded characters

            // Open in new tab instead of downloading
            window.open(reportUrl, '_blank');
            // notification.success({
            //     message: 'Report is being generated and will be sent via email when ready.'
            // });
          } else {
            console.log('Failed to generate report. Please try again.');
            // notification.error({
            //     message: 'Failed to generate report. Please try again.'
            // });
          }
          setLoadingReport(false);
        }
      })
      .catch((error) => {
        console.error('Form validation failed:', error); // Debug log
        setLoadingReport(false);
      });
  };

  const handleShareReport = () => {
    reportForm.validateFields(['email']).then(async (data) => {
      if (!data.email) {
        notification.warning({
          message: 'Provide Email to proceed!',
        });
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emails = data.email.split(',').map((email) => email.trim());
      const invalidEmails = emails.filter((email) => !emailRegex.test(email));

      if (invalidEmails.length > 0) {
        notification.error({
          message: 'Invalid email format',
          description: `Please check: ${invalidEmails.join(', ')}`,
        });
        return;
      }

      // Show loading for 1 second
      setLoadingReport(true);

      // Call the same API with emailToDestinations
      const obj = {
        fromDate: moment(startDate).startOf('day').toISOString(),
        toDate: moment(endDate).endOf('day').toISOString(),
        sowId: selectedSOW.id,
        format: 'PDF',
        weldIds: pipeline.includes('All')
          ? weldTestList.map((item) => String(item.weldId))
          : pipeline.filter((value) => value !== 'All').map(String),
        generatedBy: name,
        projectId: selectedProject.id,
        generateReport: true,
        heatProfiles: includeHeatProfile ? selectedHeatProfileIds : [],
        emailToDestinations: data.email,
      };

      // Fire and forget - don't wait for response
      OnGeneratePQtReports(obj).catch((error) => {
        console.error('Error sending report via email:', error);
      });

      // Fake loading for 1 second then close
      setTimeout(() => {
        setLoadingReport(false);
        notification.success({
          message: 'Report sent successfully!',
        });

        // Reset form and close modal
        reportForm.resetFields();
        setIsReportModalVisible(false);
        setStartDate(null);
        setEndDate(null);
        setPipeline([]);
        setEmail('');
        setName('');
        setReportGenerated(false);
        setGeneratedReportUrl(null);
        setIncludeHeatProfile(false);
        setSelectedHeatProfileIds([]);
      }, 1000);
    });
  };

  useEffect(() => {
    if (!isLogReportsLoading) {
      setLoadingReport(false);
      setIsReportModalVisible(false);
      setStartDate(null);
      setEndDate(null);
      setPipeline([]);
      setEmail('');
      setName('');
      setLoadingReport(false);
    }
  }, [isLogReportsLoading]);

  const handleCancel = () => {
    reportForm.resetFields(); //resetting input fields
    setIsReportModalVisible(false);
    setStartDate(null);
    setEndDate(null);
    setPipeline([]);
    setEmail('');
    setName('');
    setLoadingReport(false);
    // Reset heat profile demo state
    setIncludeHeatProfile(false);
    setSelectedHeatProfileIds([]);
  };

  // const onKeyDown = (event) =>{
  //     console.log(event)
  //     if(event.which === 13 || event.which === 188 || event.which === 186) {
  //         console.log("done job", email)
  //     }
  // }

  // **Handle Start Date Change**
  const handleStartDateChange = async (date, dateString) => {
    setLoadingWeldIds(true);
    dateString =
      dateString && moment(dateString).isValid() ? moment(dateString).format('YYYY-MM-DD') : '';
    if (endDate && dateString > endDate) {
      notification.warn({ message: 'From date should be before To date' });
      return;
    }
    setStartDate(dateString);
    await fetchWeldTestDetails(dateString, endDate);
    setLoadingWeldIds(false);
  };

  // **Handle End Date Change**
  const handleEndDateChange = async (date, dateString) => {
    setLoadingWeldIds(true);
    dateString =
      dateString && moment(dateString).isValid() ? moment(dateString).format('YYYY-MM-DD') : '';
    setEndDate(dateString);
    await fetchWeldTestDetails(startDate, dateString);
    setLoadingWeldIds(false);
  };
  // const [subCategoryList, setSubCategoryList] = useState([]);
  // const processSubCategories = (data) => {
  //     const weldIds = [...new Set(data.map(item => item.weldId))]; // Extract unique weldIds

  //     // Ensure 'All' is the first option
  //     if (!weldIds.includes("All")) {
  //         weldIds.unshift("All");
  //     }

  //     return weldIds.map(weldId => ({ subCategory: weldId })); // Convert to objects
  // };

  // useEffect(() => {
  //     const result = processSubCategories(weldTestList);
  //     setSubCategoryList(result);
  // }, [weldTestList]);

  // const handleSelectChange = (values) => {
  //     console.log("Selected values:", values);

  //     // Extract all weld IDs

  //     if (values.includes("All")) {
  //         if (!pipeline.includes('All')) {
  //             const allWelds = weldTestList.map(item => item.weldId);

  //             const ids = values.filter(value => value !== "All")
  //             if (ids && ids.length > 0) {
  //                 setPipeline(ids);
  //             }
  //             else // If "All" is selected, select all weld IDs
  //                 setPipeline(values);
  //         }
  //         else {
  //             setPipeline(['All']);
  //         }

  //     }

  //     else if (values.length === 0) {
  //         // If everything is deselected, clear selection
  //         setPipeline([]);
  //     } else {
  //         // If specific items are selected, remove "All" and keep the selected ones
  //         setPipeline(values.filter(value => value !== "All"));
  //     }
  // };

  const handleSelectChange = (values) => {
    //console.log("Selected values:", values);

    // If "All" is selected, keep only "All"
    if (!pipeline.includes('All') && values.includes('All')) {
      setPipeline(['All']);
    }
    // If other items are selected, remove "All"
    else {
      setPipeline(values.filter((value) => value !== 'All'));
    }
  };

  return (
    <>
      <style>
        {`
                .heat-profile-select .ant-select-selection-item {
                    color: white !important;
                    background-color: rgba(255, 255, 255, 0.1) !important;
                    border: 1px solid rgba(255, 255, 255, 0.3) !important;
                }
                .heat-profile-select .ant-select-selection-item-content {
                    color: white !important;
                }
                .heat-profile-select .ant-select-selection-item-remove {
                    color: rgba(255, 255, 255, 0.7) !important;
                }
                .heat-profile-select .ant-select-selection-item-remove:hover {
                    color: white !important;
                }
                `}
      </style>
      <Space size="middle">
        <div onClick={showModal}>
          <Button>Generate Report</Button>
        </div>
        <div onClick={showHeatProfileModal}>
          <Button> Manage Heat Profile</Button>
        </div>
        <MaterialsWeatherInspectionModal
          selectedSOW={selectedSOW}
          logDateRange={logDateRange}
          onViewDetails={onViewDetails}
        />
        <Button type="default" onClick={handleRecalculatePqtWeld}>
          Recalculate Results
        </Button>
      </Space>
      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Recalculate weld status"
        centered
        visible={isRecalculateModalVisible}
        footer={[
          <Button key="cancel" onClick={handleRecalculateModalCancel}>
            Cancel
          </Button>,
          <Button
            key="proceed"
            type="primary"
            onClick={handleRecalculateModalProceed}
            loading={pqtWeldRecalculateLoading}
          >
            Proceed
          </Button>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Recalculate test results for all welds completed on{' '}
              <b style={{ color: '#EF314C' }}>
                {recalculateModalPayload &&
                  moment
                    .utc(recalculateModalPayload.datePayload, 'YYYY-MM-DD')
                    .format('D-MMMM-YYYY')}
              </b>
              .
            </p>
            <p>Are you sure you want to proceed?</p>
          </Text>
        </div>
      </Modal>
      <div>
        <Modal
          width="40vw"
          className="pipeline-modal"
          title="Generate Report"
          visible={isReportModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              Close
            </Button>,
            <Button key="apply" type="primary" onClick={handleOk} loading={loadingReport}>
              {reportGenerated ? 'Share' : 'Generate Report'}
            </Button>,
          ]}
        >
          <Form form={reportForm} name="basic" layout="vertical">
            <Row gutter={24}>
              <Col lg={12}>
                <Form.Item
                  className="date-picker"
                  label="From"
                  name="startDate"
                  required
                  // initialValue={moment(startDate, "YYYY-MM-DD")}
                >
                  <div>
                    <DatePicker
                      placholder="From"
                      format="DD-MMM-YYYY"
                      value={startDate ? moment(startDate) : null}
                      onChange={(date, dateString) => handleStartDateChange(date, dateString)}
                    />
                  </div>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  className="date-picker"
                  label="To"
                  name="endDate"
                  required
                  // initialValue={moment(endDate, "YYYY-MM-DD")}
                >
                  <div>
                    <DatePicker
                      format="DD-MMM-YYYY"
                      value={endDate ? moment(endDate) : null}
                      onChange={(date, dateString) => handleEndDateChange(date, dateString)}
                      disabledDate={(current) => startDate && current < moment(startDate)}
                    />
                  </div>
                </Form.Item>
              </Col>

              <Col lg={12}>
                <Form.Item label="Welds" name="" required>
                  <div>
                    <Select
                      className="multi-select"
                      placeholder="Select Weld"
                      loading={loadingWeldIds}
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      mode="multiple" // Enable multiple selection
                      onChange={handleSelectChange}
                      value={pipeline}

                      // filterOption={(input, option) =>
                      //     option.children.toLowerCase().includes(input.toLowerCase())
                      // }
                      // dropdownRender={menu => (
                      //     <>
                      //         {menu}
                      //         <Divider style={{ margin: '8px 0', borderTop: '1px solid lightgrey' }} />
                      //         <Space align="center" style={{ padding: '0 8px 4px' }}>
                      //             <Input placeholder="Add Sub category" value={subCategory} onChange={(e) => setSubCategory(e.target.value)} />
                      //             <Typography.Link onClick={addSubcategoryItem} style={{ whiteSpace: 'nowrap', color: "green" }}>
                      //                 <CheckOutlined />
                      //             </Typography.Link>
                      //         </Space>
                      //     </>
                      // )}
                    >
                      {/* {subCategoryList.map((item, i) => (
                                            <Option key={i} value={item.subCategory}>{item.subCategory}</Option>
                                        ))} */}

                      {weldTestList.length > 0 && (
                        <Option key="all" value="All">
                          All
                        </Option>
                      )}
                      {weldTestList.map((item) => (
                        <Option key={item.weldId} value={item.weldId}>
                          {item.weldId}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Form.Item>
              </Col>

              <Col lg={12}>
                <Form.Item label="Generated By" name="name" required>
                  <div>
                    <Input
                      // disabled
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      size="large"
                      placeholder="Name or Email"
                    />
                  </div>
                </Form.Item>
              </Col>
              <Col lg={24} style={{}}>
                <Form.Item>
                  <Checkbox
                    checked={includeHeatProfile}
                    onChange={(e) => setIncludeHeatProfile(e.target.checked)}
                  >
                    <span style={{ fontWeight: '500' }}>Include Heat Profile</span>
                  </Checkbox>
                </Form.Item>
              </Col>
              {includeHeatProfile && (
                <Col lg={24} style={{ marginBottom: '24px' }}>
                  <Form.Item
                    label={<span style={{ fontWeight: '500' }}>Heat Profile Report Numbers</span>}
                    name="heatProfileNumbers"
                    required={includeHeatProfile}
                  >
                    <Select
                      className="heat-profile-select"
                      mode="multiple"
                      placeholder="Select Heat Profile Report Numbers"
                      value={selectedHeatProfileIds}
                      onChange={(value) => setSelectedHeatProfileIds(value)}
                      showSearch
                      optionFilterProp="children"
                      loading={loadingHeatProfiles}
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {heatProfileList &&
                        heatProfileList.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.reportNumber}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              <Col lg={24} style={{ marginBottom: '24px' }}>
                <Form.Item
                  label={<span style={{ fontWeight: '500' }}>Email</span>}
                  name="email"
                  required
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    // disabled
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="large"
                    placeholder="Enter emails followed by comma (,)"
                    // onKeyDown={onKeyDown}
                  />
                </Form.Item>
                <span style={{ fontSize: '12px', position: 'relative', left: '10px' }}>
                  eg: 1234@mail.com, 234@email.com
                </span>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>

      {/* Heat Profile Management Modal */}
      <Modal
        width="98vw"
        className="heat-profile-modal"
        title=""
        visible={isHeatProfileModalVisible}
        onCancel={handleHeatProfileCancel}
        footer={null}
        destroyOnClose={true}
        bodyStyle={{ padding: '0px', background: '#1a1a1a' }}
        style={{ top: 10 }}
      >
        {showHeatProfileForm ? (
          <div style={{ padding: '20px', background: 'white' }}>
            <ProjectHeatProfile
              selectedProject={selectedProject}
              selectedSOW={selectedSOW}
              editingRecord={editingHeatProfile}
              onClose={handleHeatProfileFormClose}
            />
          </div>
        ) : (
          <ProjectHeatProfileList
            selectedProject={selectedProject}
            selectedSOW={selectedSOW}
            setIsHeatProfileModalVisible={setIsHeatProfileModalVisible}
            onEdit={handleEditHeatProfile}
            onCreateNew={handleCreateHeatProfile}
          />
        )}
      </Modal>
    </>
  );
};

export default GenerateReport;
